export default function Resulted() {
  return (
    <div className="flex gap-1 flex-col">
      <span className="text-xl font-semibold">This raffle has ended</span>
      <span className="font-thin">Congratulations to the winner!</span>
    </div>
  );
}
